<template>
  <div
    class="not-found-page w-100 h-100 d-flex flex-column justify-content-center align-items-center"
  >
    <h3>Sorry, we can't find that page</h3>
    <p>
      Try going back to the
      <router-link :to="`/customers`">customer list</router-link>
    </p>
  </div>
</template>

<script>
export default {};
</script>
